import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
const IndicatorSeparator = _ref => {
  let {
    innerProps
  } = _ref;
  const indicatorSeparatorStyle = {
    alignSelf: 'stretch',
    margin: 8,
    width: 1
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    className: "asc-select-separator",
    style: indicatorSeparatorStyle
  }, innerProps));
};
IndicatorSeparator.propTypes = {
  innerProps: PropTypes.object
};
export default IndicatorSeparator;